<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle1"><a id="page_xi"></a><strong>A Word about Abbreviations (Acronyms) and Graphics Used in this Book</strong></p>
<p class="noindent-b">These are vital to this book. They provide a way to quickly focus on important principles and to show others what we are doing. Take a few minutes to familiarize yourself with these terms.</p>
<p class="bullet"><span class="bull">•</span> First, NBI stands for “No-Bull Information,” the theme of this book.</p>
<p class="bullet"><span class="bull">•</span> It is pronounced by saying each letter: N*B*I.</p>
<p class="bullet"><span class="bull">•</span> Arnbi is a character that will be your guide throughout the book. The “Ar” comes from Aristotle, one of the first Western philosophers to carefully examine information. The “Ar” is added in front of NBI, producing Arnbi. Arnbi is pronounced Arn (like in Arnold) and Bee. Say it a couple times, and soon it will sound natural.</p>
<p class="bullet"><span class="bull">•</span> ARNBism is a wise, profound statement made by Arnbi. It is formed by combining “Arnbi” and “ism.” Say this out loud: “optimism, ARNBism, optimism, ARNBism.”</p>
<p class="indent-t">Read the following a couple times before moving on to the heart of the book. NBI uses Arnbi and the wise, funny things Arnbi says <a id="page_xii"></a>(ARNBisms) to help us better understand and handle information in the 21st century. It’s OK to sing or chant the sentence if this helps.</p>
<p class="indent-b">Below are a few examples of this approach. I hope these will make you smile. But also understand that Arnbi serves a very important, serious function: symbolizing and focusing attention on the most important points of NBI.</p>
<p class="indent-b"><img alt="Images" src="images/f0xii-01.jpg"/> Arnbi standing alone, saddened by the information he confronts.</p>
<p class="indent-b">Arnbi holding a shovel useful for eliminating bull-laden information. <img alt="Images" src="images/NB.jpg"/></p>
<p class="indent-b"><img alt="Images" src="images/AR.jpg"/> ARNBism is a wise pronouncement from the mind of Arnbi.</p>
<p class="indent-b">SUPER-ARNBism is an extremely important rule about using information. There are only three. <img alt="Images" src="images/SM.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Abbreviations.vue?d5641ebc